var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.62,176.94S56.87,95.58,132.73,56s166.33-22.74,240-11.1,120.53,68,115.52,135.61-64.42,74-109.78,141.79-47.71,93-120.78,124.16-166.91-20.11-203-111S37.62,176.94,37.62,176.94Z",
    style: {
      fill: "#0263FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.62,176.94S56.87,95.58,132.73,56s166.33-22.74,240-11.1,120.53,68,115.52,135.61-64.42,74-109.78,141.79-47.71,93-120.78,124.16-166.91-20.11-203-111S37.62,176.94,37.62,176.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-16"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: 123,
    x2: 471,
    y2: 465,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.37,78A24.94,24.94,0,0,0,115,52.69,33.65,33.65,0,0,0,50.2,65.49c0,.41,0,.82,0,1.24a21.9,21.9,0,0,0,3,42.77v.23H152.3A15.87,15.87,0,0,0,153.37,78Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.76,
    y1: 177.82,
    x2: 228.76,
    y2: 176.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.76,
    y1: 173.36,
    x2: 228.76,
    y2: 68.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2.9668800830841064,2.9668800830841064"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "228.76 66.55 228.76 65.05 227.26 65.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.24,
    y1: 65.05,
    x2: 165.25,
    y2: 65.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "3.0249099731445312,3.0249099731445312"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163.74,
    y1: 65.05,
    x2: 162.24,
    y2: 65.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.75 176.37 228.76 185 223.78 176.37 233.75 176.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.74 138.41 209.58 138.41 209.58 86.8 235.92 86.8 246.74 97.53 246.74 138.41",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.92 86.8 235.92 97.34 246.74 97.34 235.92 86.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.32,
    y1: 104.17,
    x2: 240.99,
    y2: 104.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.32,
    y1: 111.17,
    x2: 240.99,
    y2: 111.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.32,
    y1: 118.17,
    x2: 240.99,
    y2: 118.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.32,
    y1: 125.17,
    x2: 240.99,
    y2: 125.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.98 88.46 137.82 88.46 137.82 36.85 164.16 36.85 174.98 47.58 174.98 88.46",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.16 36.85 164.16 47.39 174.98 47.39 164.16 36.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.56,
    y1: 54.22,
    x2: 169.23,
    y2: 54.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.56,
    y1: 61.22,
    x2: 169.23,
    y2: 61.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.56,
    y1: 68.22,
    x2: 169.23,
    y2: 68.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143.56,
    y1: 75.22,
    x2: 169.23,
    y2: 75.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82.4,
    y1: 416,
    x2: 82.4,
    y2: 131.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "3,3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.38 132.6 82.4 123.96 77.41 132.6 87.38 132.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.52 368.58 64.37 368.58 64.37 316.97 90.7 316.97 101.52 327.7 101.52 368.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.7 316.97 90.7 327.51 101.52 327.51 90.7 316.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.11,
    y1: 334.34,
    x2: 95.78,
    y2: 334.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.11,
    y1: 341.34,
    x2: 95.78,
    y2: 341.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.11,
    y1: 348.34,
    x2: 95.78,
    y2: 348.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.11,
    y1: 355.34,
    x2: 95.78,
    y2: 355.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.52 231.58 64.37 231.58 64.37 179.97 90.7 179.97 101.52 190.7 101.52 231.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.7 179.97 90.7 190.51 101.52 190.51 90.7 179.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.11,
    y1: 197.34,
    x2: 95.78,
    y2: 197.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.11,
    y1: 204.34,
    x2: 95.78,
    y2: 204.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.11,
    y1: 211.34,
    x2: 95.78,
    y2: 211.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.11,
    y1: 218.34,
    x2: 95.78,
    y2: 218.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 24.36 318.27 24.36 317.29 34.57 392.54 34.57 392.54 24.36",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 34.57 318.27 34.57 317.29 44.78 392.54 44.78 392.54 34.57",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 44.78 318.27 44.78 317.29 54.99 392.54 54.99 392.54 44.78",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 54.99 318.27 54.99 317.29 65.2 392.54 65.2 392.54 54.99",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 65.2 318.27 65.2 317.29 75.41 392.54 75.41 392.54 65.2",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 75.41 318.27 75.41 317.29 85.62 392.54 85.62 392.54 75.41",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 85.62 318.27 85.62 317.29 95.83 392.54 95.83 392.54 85.62",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 95.83 318.27 95.83 317.29 106.04 392.54 106.04 392.54 95.83",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 106.04 318.27 106.04 317.29 116.25 392.54 116.25 392.54 106.04",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 116.25 318.27 116.25 317.29 126.46 392.54 126.46 392.54 116.25",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 126.46 318.27 126.46 317.29 136.67 392.54 136.67 392.54 126.46",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 136.67 318.27 136.67 317.29 146.88 392.54 146.88 392.54 136.67",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 146.88 318.27 146.88 317.29 157.1 392.54 157.1 392.54 146.88",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 157.1 318.27 157.1 317.29 167.31 392.54 167.31 392.54 157.1",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.54 167.31 318.27 167.31 317.29 177.52 392.54 177.52 392.54 167.31",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 24.36 394.62 24.36 393.63 34.57 468.89 34.57 468.89 24.36",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 34.57 394.62 34.57 393.63 44.78 468.89 44.78 468.89 34.57",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 44.78 394.62 44.78 393.63 54.99 468.89 54.99 468.89 44.78",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 54.99 394.62 54.99 393.63 65.2 468.89 65.2 468.89 54.99",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 65.2 394.62 65.2 393.63 75.41 468.89 75.41 468.89 65.2",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 75.41 394.62 75.41 393.63 85.62 468.89 85.62 468.89 75.41",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 85.62 394.62 85.62 393.63 95.83 468.89 95.83 468.89 85.62",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 95.83 394.62 95.83 393.63 106.04 468.89 106.04 468.89 95.83",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 106.04 394.62 106.04 393.63 116.25 468.89 116.25 468.89 106.04",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 116.25 394.62 116.25 393.63 126.46 468.89 126.46 468.89 116.25",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 126.46 394.62 126.46 393.63 136.67 468.89 136.67 468.89 126.46",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 136.67 394.62 136.67 393.63 146.88 468.89 146.88 468.89 136.67",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 146.88 394.62 146.88 393.63 157.1 468.89 157.1 468.89 146.88",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 157.1 394.62 157.1 393.63 167.31 468.89 167.31 468.89 157.1",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.89 167.31 394.62 167.31 393.63 177.52 468.89 177.52 468.89 167.31",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.55,
    y: 16.45,
    width: 157.05,
    height: 7.7,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.61,
    y1: 24.15,
    x2: 472.61,
    y2: 159.81,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470.89,
    y1: 24.37,
    x2: 470.89,
    y2: 117.44,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 471.61,
    y: 159.51,
    width: 2.11,
    height: 3.46,
    style: {
      fill: "#263238",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 469.7,
    y: 116.7,
    width: 2.11,
    height: 3.46,
    style: {
      fill: "#263238",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.86,157.09S266.1,167.25,262,171s-27.77,79.95-27.77,79.95h165S387,199.77,384,182.49s-16.26-21-23-22.36S292.86,157.09,292.86,157.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.92 171.54 334.38 250.92 362.99 250.92 351.49 164.59 337.92 171.54",
    style: {
      fill: "#0263FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.14,150.43s-4.42,6.49-3.54,8.56,10.92,17.7,20.95,19.47,22.71-3.84,29.5-8,15.63-7.37,17.1-8.26-3.83-8-6.19-9.14-5.31-3-5.31-3-3.24-4.13-3.83-5-.89-2.36-1.77-3.54a3.94,3.94,0,0,0-2.95-1.77c-1.48-.29-3.54,7.08-12.39,8.56s-30.39,2.36-30.39,2.36Z",
    style: {
      fill: "#0263FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.58,178.46s17.11-8.56,19.17-15.34,2.07-18,2.07-18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.56,171.08s7.37-3.24,9.73-7.67,2.36-13.27,2.36-13.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.65,113.76c-.32,1.2,6.59,35.46,11.54,44.12s15.25,13.6,21.44,10.72c7.16-3.35,15.05-9.92,18.47-17.21.63-1.35,4.12-15.94,3.38-16.19,0,0,4.95,1.65,7-7.42s3.71-14.43,1.24-19.38S332.24,91.91,319.45,94,287.71,105.93,285.65,113.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.87,103s-18.14,14-30.51,15.26S277,113.76,277,113.76s-16.08,4.54-14.43-7.83S289,83.66,289,83.66s-8.66-2.47-4.54-7,19.79-9.49,30.1-8.25,14.84,3.71,14.84,3.71-2.89-7.42,3.3-5S344.19,81.6,344.19,81.6s10.72.83,11.55,3.71S349.55,89,349.55,89s6.6,12.37,3.3,19.38-10.31,9.07-10.72,10.31,1.24,5.77-2.06,4.12-4.54-8.66-4.54-8.66-4.94-4.94-5.36-7-.82-4.53-.82-4.53-2.89,8.66-9.48,9.89S319.87,103,319.87,103Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,132.73s-8.24,18.14-3.71,18.55,8.66-4.54,8.66-4.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.44,154.17s5.36,5.77,15.25-2.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.24,136.35s1,3.73,8.47,3.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.65,135.67s-2.37,3.05-5.08,3.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.38,127s-19.11-.41-21.17.42-2.47,5.77-1.24,9.07,4.13,7.83,11.55,7.83,11.13-3.71,13.6-10.72S332.38,127,332.38,127Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,127s14.71-.41,16.3.42,1.9,5.77,1,9.07-3.18,7.83-8.89,7.83-8.57-3.71-10.47-10.72S285.22,127,285.22,127Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.02,
    y1: 129.33,
    x2: 342.3,
    y2: 121.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.21,
    y1: 127.37,
    x2: 301.42,
    y2: 127.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.7,
    y1: 131.35,
    x2: 302.63,
    y2: 131.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283,
    y1: 128.92,
    x2: 287.66,
    y2: 125.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.81,134.36c0,1.54-.73,2.8-1.63,2.8s-1.62-1.26-1.62-2.8.73-2.8,1.62-2.8S320.81,132.81,320.81,134.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.27,133.18c0,1.55-.72,2.8-1.62,2.8s-1.62-1.25-1.62-2.8.73-2.8,1.62-2.8S299.27,131.63,299.27,133.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.6,123.59s5.9-2.36,8.85-.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,123.3a16.39,16.39,0,0,1,12.1,1.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.75,241.05a18.36,18.36,0,0,0-14.91-2c-8.13,2.37-12.19,9.49-12.19,11.86h34.21A14.85,14.85,0,0,0,219.75,241.05Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.74,232.92s-4.4,6.44-4.4,8.81-2.37,4.74,1,5.76,5.42-10.84,5.42-12.19S198.74,232.92,198.74,232.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.84,232.58s-4.74-1-6.1.34-3.72,13.22-3.38,14.57,3.72,1.69,4.74.34S204.84,232.58,204.84,232.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.17,238s-14.23-5.09-17.28-7.12-4.74,2-5.76,4.41-3.39,10.84-3.39,13.21,3.73,3.38,4.41.67,6.1-11.51,6.1-11.51l7.11,2.71s.68,1-2.37,3.05-7.45,6.43-6.1,7.11,5.42.34,6.78-1,8.46-3.05,8.46-3.05,6.44,4.07,7.8,4.41,9.82-1.36,9.82-1.36-9.49-8.13-10.84-9.14A29.12,29.12,0,0,0,225.17,238Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.5,232.74h-7.11c-3.05,0-9.15-2-9.49,1.35s6.78,5.42,10.16,5.42,5.42-1.35,9.49.68,6.44,3.39,6.44,3.39l-4.75-7.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.62,250.35s-6.44-13.89-9.49-18.29-21-7.79-23-7.79-7.12,11.18-6.44,13.89,2-.34,3-2,4.74-6.43,4.74-6.43,5.76,9.48,8.13,14.56,7.12,5.76,9.83,6.44S381.62,250.35,381.62,250.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,230s-6.44-8.47-9.83-7.12-8.8,17.62-9.48,19.65,3.39.68,4.06-1,6.78-10.5,6.78-10.5l5.42,3.39",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.76,230s-6.77-5.76-9.15-5.09-10.84,17.28-9.48,18,4.06-.68,5.42-2.71,4.06-6.78,4.06-6.78l5.09,3.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.07,234.66s-3.31-6.67-5.68-5.65-10.5,13.55-8.13,13.55,9.49-7.45,9.49-7.45-.68,5.76,0,8.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.69,
    y: 248.17,
    width: 88.89,
    height: 2.75,
    transform: "translate(638.26 499.09) rotate(180)",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.79 190.35 299.07 190.35 317.16 250.92 227.88 250.92 209.79 190.35",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.24,
    y1: 250.92,
    x2: 487.67,
    y2: 250.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cat--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412,218.41s1.47,15.63.59,20.65-3.25,5.6-3.84,8,3.84,2.07,6.49,1.77,5.6-13,8.85-28.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.53,246.87s-6.72.79-6.92,2.57,1.18,3.16,6.32,3.36,18.38-.39,20.56-1.58-4.94-3-9.29-3.56S435.53,246.87,435.53,246.87Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.24,184.78s-7.08,5.31-7.67,17.41S409,223.42,414,225.49s11.21,4.13,13,5.6,2.22,10,4.72,13.87c3.81,5.87,14.16,8.26,27.14,6.78s13.23-15.74,14.45-25.37C474.75,215,468,196,459.74,191s-21.53-3.54-25.66-4.43a17,17,0,0,1-7.38-4.13A17.05,17.05,0,0,0,407.24,184.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.34,182c1.09,3.5-3.33,8-9.86,10s-12.71.84-13.8-2.66,3.32-8,9.86-10S428.25,178.48,429.34,182Z",
    style: {
      fill: "#0263FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.89,195.72a3.52,3.52,0,1,1-4.4-2.32A3.53,3.53,0,0,1,416.89,195.72Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.22,216.64s0,14.75-.59,20.94-1.77,7.67-3.54,8.85-2.07,3.25.59,4.13,6.19-.29,7.07-1.47,6.79-16.82,10.92-30.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.89,239.16s7.91,4.91,5.55,11.7-28.32,8.26-47.79,8.26-39.82-1.48-38-8,15.93-2.06,29.79-1.18,43.59,1.13,46.32-2.65A36.67,36.67,0,0,0,471.89,239.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.86,159.23a47.63,47.63,0,0,0,4.33,6.68,16.07,16.07,0,0,0,3.27,3.19s3.85-6.27,2.51-8.92S382.86,159.23,382.86,159.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.54,143.81a18.57,18.57,0,0,1,1.28,6.82c0,4-.85,5.6-.85,5.6l-7.53-3.38S423.22,144.84,425.54,143.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.65,162.38s-5.12,10.17-1.47,16.67,12,8.76,15.63,9.2,9.7,1.94,15.14-3.07,6.18-5.34,6.18-5.34,7.88-8.18,6.49-17S420.56,152,420.56,152l5-8.19s-7.11,2.44-9.38,4a46.71,46.71,0,0,1-4.39,2.59,25.69,25.69,0,0,0-9.08,1.54,53.8,53.8,0,0,0-9.08,5.33s-11.36.78-10.75,2S391.65,162.38,391.65,162.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.75,177.88a8.19,8.19,0,0,0,4.29-.77c2.11-1.07,1.25-2.27-.06-2.37a7.75,7.75,0,0,0-4,1.27C406,176.62,405.74,177.12,406.75,177.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.07,172.59s-4,1.12-4.33,3.44,2.29,3.88,3.9,2.57a5.73,5.73,0,0,0,1.95-2.94s4.09,2.29,5.86.77,2.31-3.67.74-4.77S407.07,172.59,407.07,172.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.1,171.82s-3.33.67-3.68,1.22,1,2.78,2.28,2.27a3.48,3.48,0,0,0,1.81-2.43A1,1,0,0,0,410.1,171.82Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4,168.94c.76,1.51.74,3.06-.06,3.45s-2-.5-2.8-2-.74-3.06,0-3.45S400.64,167.43,401.4,168.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.49,165.4c.68,1.55.57,3.09-.24,3.45s-2-.62-2.7-2.17-.57-3.09.24-3.44S412.81,163.85,413.49,165.4Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.66,470.89a20.5,20.5,0,0,1-7.24-1.72,2.5,2.5,0,1,1,2-4.6c2.31,1,5.27,1.58,6.07,1.24,1.45-1.63,3.7-11.53.8-16.25a2.31,2.31,0,0,0-1.66-1.3c-1.65-.22-4.09,1.47-4.95,2.28a2.5,2.5,0,0,1-3.41-3.66c.46-.43,4.61-4.18,9-3.58a7.24,7.24,0,0,1,5.25,3.64c4.27,6.94,1.34,20.17-1.93,22.79A6.23,6.23,0,0,1,324.66,470.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.6,
    y: 441.25,
    width: 27.63,
    height: 36.67,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.11,439.24s0-3.05,5.59-6.1,8.66-7.64,5.6-16.29-2.54-14.76,3.57-19.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.38,406.69c.28-3.72,1.95-6.86,5.34-9.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.16,416.85a37,37,0,0,1-1.35-4.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84,419.83a24,24,0,0,0-.85-3c-.16-.47-.32-.93-.46-1.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.79,439.24s0-3.05,5.6-6.1c3.68-2,6.25-4.67,6.73-8.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.47,434s-3.1-3.94-6.47-5.62-10.4-3.1-10.4-3.1,6.18-1.4,11-.28,8.16,5.91,8.16,5.91-1.41-2-3.38-7.88-2-18.55-2-18.55a40,40,0,0,1,7,11.81,58.73,58.73,0,0,1,2.81,12.09s-.56-9.84,1.13-15.46,6.46-12.65,6.46-12.65.28,12.36-1.68,19.11-2.82,9.84-2.82,9.84a24.26,24.26,0,0,1,5.91-9.28c4.21-3.93,14.33-7.31,14.33-7.31s-4.78,8.72-7.87,11.53-6.18,5.9-6.18,5.9a16.33,16.33,0,0,1,9.27-2.53c5.91,0,12.93,3.94,12.93,3.94s-20.51-.28-24.45,3.09Z",
    style: {
      fill: "#0263FF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.28,
    y1: 432.48,
    x2: 367.82,
    y2: 430.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.01,
    y1: 434.35,
    x2: 370.22,
    y2: 421.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.48,
    y1: 435.95,
    x2: 377.68,
    y2: 417.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.01,
    y1: 434.35,
    x2: 384.07,
    y2: 423.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.24,
    y1: 433.2,
    x2: 386.47,
    y2: 429.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.05,477.92H363l-1.27-10.19a95.45,95.45,0,0,1-.13-22.41l1.4-12.45h28.1l1.38,12.18a94.74,94.74,0,0,1-.1,22.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "392.91 458.78 388.7 433.2 383.07 477.33 373.24 433.2 367.33 477.9 362.95 432.87",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.05,477.92H363l-1.27-10.19a95.45,95.45,0,0,1-.13-22.41l1.4-12.45h28.1l1.38,12.18a94.74,94.74,0,0,1-.1,22.39Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 132.46,
    cy: 268,
    r: 36.5,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.46,
    cy: 268,
    r: 29.2,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.91,268a4.55,4.55,0,1,0,4.55-4.54A4.55,4.55,0,0,0,127.91,268Z",
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.46,
    y1: 272.54,
    x2: 132.46,
    y2: 289.75,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137,
    y1: 268,
    x2: 147.69,
    y2: 268,
    style: {
      fill: "none",
      stroke: "#b2b2b2",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-16"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 437,
    y1: 477.92,
    x2: 12.03,
    y2: 477.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.65,349s-2.67,18.3,0,21.74,8.77,6.1,17.54,8.77,14.49-3.06,22.87,6.48,15.26,33.93,19.83,41.56S277.81,447,279,455.81s-2.67,13.72-10.3,14.87-21-17.54-22.49-20.21S237.39,439,237.39,439s-4.2,30.89-4.2,32.41.38,6.48.38,6.48H123.76s8.39-45.75,10.67-61.77,1.15-26.69,10.3-32.41,17.54-4.19,23.64-6.1,9.91-3.43,10.3-6.86.38-19.45.38-19.45Z",
    style: {
      fill: "#0263FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "127.72 459.88 77.5 473.1 81.47 477.94 138.74 477.94",
    style: {
      fill: "#0263FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,468.05a18.34,18.34,0,0,0-14.9-2c-8.13,2.37-12.2,9.49-12.2,11.86H78.22A14.84,14.84,0,0,0,71.1,468.05Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1,459.92s-4.41,6.44-4.41,8.81-2.37,4.74,1,5.76,5.42-10.84,5.42-12.19S50.1,459.92,50.1,459.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,459.59s-4.75-1-6.1.33-3.73,13.22-3.39,14.57,3.73,1.69,4.74.34S56.2,459.59,56.2,459.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.76,469.8l-8-.91a13.24,13.24,0,0,0-1.48-1.51A28.72,28.72,0,0,0,76.52,465s-14.23-5.09-17.28-7.12-4.74,2-5.75,4.41-3.39,10.84-3.39,13.21,3.72,3.38,4.4.67,6.1-11.51,6.1-11.51l7.11,2.71s.68,1-2.37,3.05-7.45,6.43-6.1,7.11,5.42.34,6.78-1,8.47-3,8.47-3,6.44,4.07,7.79,4.41a15.63,15.63,0,0,0,2.64.16h8.26A8.71,8.71,0,0,0,90.76,469.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.21,469.8s3-3.42,5.43-3.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,442.11a97.93,97.93,0,0,1,10.63,4.15c4.93,2.33,6.75,8,6,15.05s-5.71,12.46-13,10.38-11.16-8-11.42-12.72S252.84,443.66,263,442.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.91,401.66c-17.16-.61-28.29-11.18-34.94-20.86,6.69-2.24,12.72-1.7,17.4-3.16,6.1-1.91,9.91-3.43,10.3-6.86s.38-19.45.38-19.45l28.6-2.29s-2.67,18.3,0,21.74,8.77,6.1,17.54,8.77c3.84,1.16,7.09.72,10.25.66C230.29,385.83,212.61,402.61,185.91,401.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,362.79a39.42,39.42,0,0,0,7.1,5.45c4.58,2.58,12.42.29,14.71-2.57,1.12-1.4,3.43-4.16,5.9-7.48.35-4.83,1-9.15,1-9.15l-28.6,2.29S179.05,357.34,179,362.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.34,408.63s-15.57,20.5-17.13,29.07S242.72,467,242.72,467s-15.05,6.49-24.65,6.75-26.21-1.3-26.21-1.3S202.5,445,206.65,431.21s5.19-21.54,5.19-21.54,23.62,3.11,37.11,0L269.19,405Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6,451.61s-1.9-24-4.19-24.78-16-2.67-19.83-1.91-5,2.29-1.9,3.05,8.38,1.53,10.67,1.91a68.55,68.55,0,0,1,7.63,2.29s-8.39,1.14-11.82,1.14-11.44,3.43-11.82,5a3.59,3.59,0,0,0,.38,2.67,4.39,4.39,0,0,0,.06,2.39c.38,1.53,9.47.77,11.76,1.15S253.4,446,253.4,446s-13.34-.76-13.34,1.91,5.71,2.28,8,2.28a15.38,15.38,0,0,1,7.63,3.05c1.14,1.15.76,7.13,4.19,8.28a18.18,18.18,0,0,0,4.58,1.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.72,440.94s15.25-3.44,22.88.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,420.35s-6.1,21.35-4.95,29,4.57,16.39,4.95,17.54-1.34,10.19-1.34,10.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.43,302.14c3.43-3.43,0-5.34.38-9.15s4.19-5.72,6.1-6.48,1.14-2.67,1.53-6.87,4.95-5.72,8-6.86,1.15-3,2.67-6.1,9.92-2.29,9.92-2.29,1.9-3.43,4.19-3.43,3.81,3.05,6.86.38,5.72-3.81,9.92-2.29a30.32,30.32,0,0,0,4.17,1.32,30,30,0,0,0,4.18-1.32c4.19-1.52,6.86-.38,9.91,2.29s4.58-.38,6.87-.38,4.19,3.43,4.19,3.43,8.39-.76,9.92,2.29-.39,4.95,2.66,6.1,7.63,2.67,8,6.86-.38,6.1,1.53,6.87,5.72,2.66,6.1,6.48-3,5.72.38,9.15,6.86,6.1,3.81,8.39-6.1,3.05-5.72,6.48,4.2,7.63,1.15,9.53-6.1,1.91-6.1,5.34,1.14,8.39-2.29,9.15-8.39,0-8.39,2.29-.38,6.48-5.72,5.72-7.24-2.29-8.39.76-3.81,5-6.86,4.58-7.25-.76-9.92,1.52a9.25,9.25,0,0,1-4.54,1.88v.13c-.26,0-.52,0-.78,0s-.52,0-.78,0v-.13a9.33,9.33,0,0,1-4.54-1.88c-2.67-2.28-6.86-1.9-9.91-1.52s-5.72-1.53-6.86-4.58-3.05-1.52-8.39-.76-5.72-3.43-5.72-5.72-5-1.52-8.39-2.29-2.29-5.72-2.29-9.15-3-3.43-6.1-5.34.76-6.1,1.14-9.53-2.67-4.19-5.72-6.48S136,305.57,139.43,302.14Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,323.21s-4.34-6.51-6.95-3.47-1.73,10.85,1.74,14.76,7.37,2.6,7.37,2.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.41,322.88s5.07-6,7.3-2.64.45,11-3.45,14.45-7.63,1.73-7.63,1.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,307.48a6.91,6.91,0,0,1-5.72,1.71,17.77,17.77,0,0,1-5.43-1.71s-3.43,2.29-6,1.43-5.44-1.72-5.44-1.72a8.85,8.85,0,0,1-6.29,1.15c-4-.58-5.15-1.43-5.15-1.43s-2.29,2-4.57,2a33.6,33.6,0,0,1-4.29-.29,5.71,5.71,0,0,1-2,.57h-2s-.85,17.16,2,29.46,14,21.45,18.59,24,12.43.29,14.72-2.57,9.59-11.44,13-18.88,4.58-29.17,4.58-30.6S216,310.91,214.6,307.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,317.49a2.09,2.09,0,0,0-1.27,2c.1,3.24.58,10.94,2.83,12.29,2.86,1.71,16.21,3,19.45.85,1.71-1.14,5.43-11.15,4-14S209.9,312.79,198.46,317.49Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.63,317.49a2.09,2.09,0,0,1,1.27,2c-.1,3.24-.58,10.94-2.83,12.29-2.86,1.71-16.21,3-19.45.85-1.71-1.14-5.43-11.15-4-14S178.19,312.79,189.63,317.49Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.46,317.49s-5.3-1.15-8.74.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.59,
    y1: 320.92,
    x2: 191.15,
    y2: 320.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.17,
    cy: 325.21,
    rx: 1.72,
    ry: 3.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.72,
    cy: 325.21,
    rx: 1.72,
    ry: 3.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,327.21s-.29,4,1.14,5.43,3.14,2.58,1.14,4-3.71,2.57-6.57,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.16,342.65s-7.15,3.44-13.44-1.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.6,318.92a8.44,8.44,0,0,0-8-1.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.15,318.63s-6.58-3.43-10.3,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "210.89 373.25 188.58 428.16 175.42 375.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.72,430.74a3.15,3.15,0,1,0,3.15-3.15A3.15,3.15,0,0,0,185.72,430.74Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.79,
    y: 475.25,
    width: 86.18,
    height: 2.67,
    transform: "translate(321.76 953.18) rotate(180)",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.88 419.2 141.43 419.2 158.97 477.92 72.42 477.92 54.88 419.2",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.e66fa7e787cf5594350902ec5506ab3b.svg";
export { ForwardRef as ReactComponent };